import React, {FC, useEffect, useState} from "react";
import {
  PropertyFreeTextInfosRequest,
  PropertyFreeTextsInfo
} from "../../../../../../../../../../models/PropertyFreeTextInfos";
import styled from "styled-components/macro";
import {
  TextField as MuiTextField,
  IconButton as MuiIconButton,
  Typography,
  Box,
  CircularProgress
} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {Delete as DeleteIcon} from "@material-ui/icons";
import {GradientButton} from "../../../../../../../../property-page-components/PropertyForm";
import CustomTabs from "../../../../../../../../../../components/CustomTabs";
import {Languages} from "../../../../../../../../../../constants/languages";
import {useSelector} from "../../../../../../../../../../redux/store";
import {useDispatch} from "react-redux";
import {
  createPropertyFreeTextInfos, deletePropertyFreeTextInfos,
  updatePropertyFreeTextInfos
} from "../../../../../../../../../../redux/actions/propertyActions";
import {useParams} from "react-router-dom";
import Swal from "sweetalert2";
import * as types from "../../../../../../../../../../constants";
import AbsoluteLoading from "../../../../../../../../../../components/AbsoluteLoading";
import {Tooltip} from "@mui/material";
import {removeSuffix} from "../../../../../../../../../../utils/functions";
import i18n from "../../../../../../../../../../translations/i18n";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import {translateText} from "../../../../../../../../../../services/translateService";

const IconButton = styled(MuiIconButton)`
  color: #78909C
`

const Wrapper = styled.div`
  position: relative;
  background: #233145;
  //padding: 30px 20px;
  width: 100%;
  min-width: 800px;
  table {
    width: 100%;
  }
`

const TextField = styled(MuiTextField)`
  margin-top: 15px;
  //max-width: 800px;
  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
`

const WrapperData = styled.div`
  padding: 20px 20px 30px 20px;
  display: flex;
  flex-direction: column;
  background: #00000017;
`

const WrapperHeader = styled.div`
  padding: 30px 20px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Item = styled.div`
  display: flex;
  align-items: center;
  position: relative
`

const CustomGradientButton = styled(GradientButton)`
  width: 116px;
`

type PropsType = {
}

const INITIAL_DATA = [
  {
    id: '',
    text: {
      en: ''
    },
    is_displayed: true,
    property: ''
  },
  {
    id: '',
    text: {
      en: ''
    },
    is_displayed: true,
    property: ''
  },
  {
    id: '',
    text: {
      en: ''
    },
    is_displayed: true,
    property: ''
  },
]

const EditFreeTexts: FC<PropsType> = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const user = useSelector((state) => state.authReducer.user);
  const companyByProperty = useSelector((state) => state.companyReducer.companyByProperty);
  const [currentTabFreeText, setCurrentTabFreeText] = useState(0)
  const [currentLanguage, setCurrentLanguage] = useState('en')
  const [editData, setEditData] = useState<any>([...INITIAL_DATA])
  const [loading, setLoading] = useState<boolean>(false)
  const propertyFreeTextInfos = useSelector((state) => state.propertyReducer.propertyFreeTextInfos)
  const params: {id: string} = useParams()

  useEffect(() => {
    let preparedData: any = [...INITIAL_DATA]
    if (propertyFreeTextInfos && propertyFreeTextInfos.length > 0) {
      for (let i = 0; i < propertyFreeTextInfos.length; i++ ) {
        preparedData[i] = propertyFreeTextInfos[i]
      }
    }
    setEditData([...preparedData])
  }, [propertyFreeTextInfos]);

  const namesLanguages: { [key: string]: any } = {
    [Languages.English]: t("LanguagesDropdown_English"),
    [Languages.Swedish]: t("LanguagesDropdown_Swedish"),
    [Languages.Danish]: t("LanguagesDropdown_Danish"),
    [Languages.German]: t("LanguagesDropdown_German"),
    [Languages.Spanish]: t('LanguagesDropdown_Spanish'),
    [Languages.French]: t("LanguagesDropdown_French"),
    [Languages.Norwegian]: t("LanguagesDropdown_Norwegian"),
    [Languages.Portuguese]: t("LanguagesDropdown_Portuguese"),
    [Languages.Ukrainian]: t("LanguagesDropdown_Ukrainian"),
  }

  const getFreeTextTabs = () => {
    if (companyByProperty && companyByProperty.supported_languages) {
      return companyByProperty.supported_languages.map((item) => namesLanguages[item])
    }
    return [t("LanguagesDropdown_English")]
  }

  useEffect(() => {
    if (companyByProperty && companyByProperty.supported_languages) {
      const iso = companyByProperty.supported_languages[currentTabFreeText]
      setCurrentLanguage(iso ? iso : 'en')
    }
  }, [currentTabFreeText]);

  const getToastMessage = async (message: string, type?: string) => {
    await dispatch({
      type: types.ADD_TOAST,
      payload: {
        message: message,
        type: type
      }
    })
  }

  const handleSaveFreeText = async (data: PropertyFreeTextsInfo[]) => {
    setLoading(true)
    for (let index = 0; index < data.length; index++) {
      if (data[index].id && propertyFreeTextInfos) {
        const existItem = propertyFreeTextInfos.find((i) => i.id === data[index].id)
        if (existItem) {
          if (data[index].text.en === '') {
            await getToastMessage(`The free text field ${index + 1} for English cannot be empty`)
            setLoading(false)
          } else {
            const newData: PropertyFreeTextInfosRequest = {
              text: data[index].text,
              is_displayed: data[index].is_displayed,
              property: data[index].property
            }
            await dispatch(updatePropertyFreeTextInfos(newData, user!.token, data[index].id))
          }
        }
      } else if (Object.values(data[index].text).some((i: any) => i.trim() !== '')) {
        if (!data[index].text.en || data[index].text.en === '') {
          await getToastMessage(`The free text field ${index + 1} for English cannot be empty`)
          setLoading(false)
        } else {
          const newData: PropertyFreeTextInfosRequest = {
            text: data[index].text,
            is_displayed: true,
            property: params.id,
          }
          await dispatch(createPropertyFreeTextInfos(newData, user!.token))
        }
      }
    }
    setLoading(false)
  }

  const handleDeleteFreeText = (data: PropertyFreeTextsInfo | undefined) => {
    Swal.fire({
      title: t('imagesPage_Are_your_sure'),
      text: t('if_you_do_this_the_item_will_disappear'),
      confirmButtonText: t('yes_delete'),
      cancelButtonText: t('CLP_Cancel'),
      showCancelButton: true,
      reverseButtons: true,
      width: '400px',
      padding: '18px'
    }).then(async (result) => {
      if (result.isConfirmed && data) {
        setLoading(true)
        await dispatch(deletePropertyFreeTextInfos(data.id, user!.token))
        setLoading(false)
      }
    })
  }

  const handleTextChange = (index: number, newText: string) => {
    const updatedEditData = [...editData];
    updatedEditData[index] = {
      ...updatedEditData[index],
      text: {
        ...updatedEditData[index].text,
        [currentLanguage]: newText
      }
    };
    setEditData(updatedEditData);
  }

  const handleTranslateText = async (index: number, text: string) => {
    setLoading(true);
    const data = {
      text: text,
      source_language_code: removeSuffix(i18n.language),
      target_language_code: currentLanguage,
    }
    translateText(data, user!.token).then((response: any) => {
      if (response.translated_text) {
        handleTextChange(index, response.translated_text);
      }
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  return (
    <Wrapper>
      <WrapperHeader>
        <Typography
          style={{
            fontSize: 15,
            fontWeight: 800,
            marginBottom: 10,
          }}
        >
          {t('you_can_write_free_texts')}
        </Typography>
        <Box display='flex'>
          <Box ml={2} mr={2}>
            <CustomGradientButton
              // disabled={handleDisabledButton()}
              onClick={() => handleSaveFreeText(editData)}
            >
              {t('propertyForm_save')}
            </CustomGradientButton>
          </Box>
        </Box>
      </WrapperHeader>
      <Box mt={4}>
        <CustomTabs
          tabs={getFreeTextTabs()}
          value={currentTabFreeText}
          setValue={setCurrentTabFreeText}
        />
      </Box>
      <WrapperData>
        {editData.map((item: any, index: number) => (
          <Item key={index}>
            <TextField
              autoFocus={index === 0}
              fullWidth
              variant="outlined"
              value={item.text && item.text[currentLanguage] ? item.text[currentLanguage] : ''}
              placeholder={`Free text number ${index + 1} on ${namesLanguages[currentLanguage]} language. Max 40 characters`}
              onChange={(e) => handleTextChange(index, e.target.value)}
              InputLabelProps={{shrink: false}}
              inputProps={{ maxLength: 40 }}
              style={{background: '#233145'}}
            />
            {currentLanguage !== 'en' && (
              <Box position={'absolute'} top={17} right={57}>
                <Tooltip title={`Translate automatically from ${namesLanguages[removeSuffix(i18n.language)]}`} placement={'top'} arrow>
                  <IconButton
                    color={'inherit'}
                    disabled={!item.text[removeSuffix(i18n.language)] || loading}
                    onClick={() => handleTranslateText(index, item.text[removeSuffix(i18n.language)])}
                  >
                    <GTranslateIcon/>
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            <Box ml={2} mt={2}>
              <IconButton
                disabled={!item.id}
                aria-label="delete"
                onClick={() => handleDeleteFreeText(item)}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Item>
        ))}
      </WrapperData>
      <AbsoluteLoading visible={loading} />
    </Wrapper>
  )
}

export default EditFreeTexts